// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.da1xxH{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}.da1xxH:hover{opacity:.7}.mDuOx8{visibility:hidden !important;width:0 !important;min-width:0 !important;height:0 !important;min-height:0 !important;margin:0 !important;padding:0 !important;opacity:0 !important}.ggsvH7{position:relative;display:flex;align-items:center;justify-content:center}.v1wZFr{width:26px;min-width:26px;height:26px;min-height:26px;transition:transform .2s}[data-playable-hook='player-container'][data-playable-in-full-screen="true"] .v1wZFr{width:35px;height:35px}.v1wZFr:hover{transform:scale(1.18)}.v1wZFr .oPzrJW{display:block}.v1wZFr .YQ6oSz{display:none}.v1wZFr.YyRM5m:hover{transform:scale(0.8)}.v1wZFr.YyRM5m .oPzrJW{display:none}.v1wZFr.YyRM5m .YQ6oSz{display:block}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controlButton": `da1xxH`,
	"hidden": `mDuOx8`,
	"fullScreenControl": `ggsvH7`,
	"fullScreenToggle": `v1wZFr`,
	"enterIcon": `oPzrJW`,
	"exitIcon": `YQ6oSz`,
	"inFullScreen": `YyRM5m`
};
export default ___CSS_LOADER_EXPORT___;
